import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { Toast } from 'vant';
import { showFailToast } from 'vant';
import { showLoadingToast } from 'vant';
const service: any = axios.create({
    baseURL: process.env.VUE_APP_URL,
    timeout: 30000,
});


service.interceptors.request.use(
    function <T>(config: T): T {
        // id = layer.load(0)
        // console.log(config);
        showLoadingToast({
            message: '加载中...',
            forbidClick: true,
            duration: 3,
        });
        return config
    },
    function (error: object) {
        return Promise.reject(error);
    }
)

service.interceptors.response.use(
    function (response: any) {
        let data: any = response.data;
        
        if (data.errno) {
            if (data.errno == 0) {
                // Notification.success(data.errmsg)
            } else {
                console.log(data);
                showFailToast(data.errmsg);

            }
        } else {

        }

        return data

    },
    function (error: any) {
        // layer.close(id)
        if (error.response.status == 500) {
            // Notification.error('接口错误')
            // Notification.error('网络异常,请稍后再试')
        }
        return Promise.reject(error);
    }

)

const callApi = function (url: string, method = "GET", data = {}) {
    return service({
        url,
        method,
        data: method === "POST" ? data : {},
        params: method === "GET" ? data : {},
        // responseType:"arraybuffer",
    });
};
const exApi = function (url: string, method = "GET", data = {}) {
    return service({
        url,
        method,
        data: method === "POST" ? data : {},
        params: method === "GET" ? data : {},
        responseType: 'blob',
    });
};

export const getApi = (url: string, data: object) => callApi(url, "GET", data);
export const postApi = (url: string, data: object) => callApi(url, "POST", data);
export const exportApi = (url: string, data: object) => exApi(url, "POST", data)